import { usePage } from "@inertiajs/react";
import posthog from "posthog-js";
import { useEffect } from "react";

export function initPosthog({ capture_pageview = true }: { capture_pageview?: boolean } = {}) {
  if (!posthogEnabled()) return;

  posthog.init("phc_pngh4Yjb1eJ6cNJLZJHx0V4bIFX22ryHQvst33NDhbG", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "always",
    capture_pageview,
  });

  return posthog;
}

function posthogEnabled() {
  // return true
  const env = document.querySelector("meta[name='env']")?.getAttribute("content") || undefined;
  return env !== "development";
}

export function useTrackPageView() {
  const page = usePage();

  useEffect(() => {
    posthog.capture("$pageview", {
      component: page.component,
    });
  }, [page.url]);
}
